module.exports = __webpack_public_path__ + "static/media/ANIVERSARIO_small.e4606886.png";